import "./ClientMedicalFemaleOnlyFormComponent.scss";
import CardComponent from "../../../../shared/components/card/CardComponent";
import * as Yup from "yup";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import {Misc} from "../../../../constants";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import FormikRadioButtonGroupComponent
    from "../../../../shared/components/form-controls/formik-radio-button-group/FormikRadioButtonGroupComponent";
import {IClientMedicalFemaleOnlyForm} from "../../../../shared/models/client.model";
import {useDispatch} from "react-redux";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../../shared/components/status-card/StatusCardComponent";
import HeadingWithNavigationComponent
    from "../../../../shared/components/heading-with-navigation/HeadingWithNavigationComponent";
import DetailsViewCardComponent from "../../../../shared/components/details-view-card/DetailsViewCardComponent";
import HorizontalLineV2Component from "../../../../shared/components/horizontal-line-v2/HorizontalLineV2Component";
import AcknowledgementFormComponent from "../../acknowledgement-form/AcknowledmentFormComponent";
import ModalComponent from "../../../../shared/components/modal/ModalComponent";

interface ClientMedicalFemaleOnlyFormComponentProps {
    onCancel: () => void;
    onNext?: () => void;
    clientId: string;
    onSave: (clientPersonalHabits: any) => void;
    clientMedicalHistoryDetails: any;
    isClientMedicalHistoryDetailsLoaded: boolean | undefined;
    isClientMedicalHistoryDetailsLoading: boolean | undefined;
    isClientMedicalHistoryDetailsLoadingFailed: boolean | undefined;
}

const ClientMedicalFemaleOnlyValidationSchema = Yup.object({
    females_only_questions: Yup.object({
        "Pregnant or trying to get pregnant?": Yup.string().required('Pregnant or trying to get pregnant is required'),
        "Nursing?": Yup.string().required('Nursing is required')
    }),
});

const ClientMedicalFemaleOnlyInitialValues: IClientMedicalFemaleOnlyForm = {
    "females_only_questions": {
        "Pregnant or trying to get pregnant?": "",
        "Nursing?": ""
    }
};

const FormQuestions = [
    {
        key: "Pregnant or trying to get pregnant?",
        title: "Pregnant or trying to get pregnant?",
    },
    {
        key: "Nursing?",
        title: "Nursing?",
    }
]

const ClientMedicalFemaleOnlyFormComponent = (props: ClientMedicalFemaleOnlyFormComponentProps) => {

    const {
        onCancel, onSave,
        clientId,
        clientMedicalHistoryDetails,
        isClientMedicalHistoryDetailsLoading,
        isClientMedicalHistoryDetailsLoadingFailed
    } = props;
    const [clientMedicalFemaleOnlyInitialValues, setClientMedicalFemaleOnlyInitialValues] = useState<IClientMedicalFemaleOnlyForm>(_.cloneDeep(ClientMedicalFemaleOnlyInitialValues));
    const [isClientMedicalFemaleOnlyFormSavingInProgress, setIsClientMedicalFemaleOnlyFormSavingInProgress] = useState(false);
    const dispatch = useDispatch();
    const [isAcknowledgementModalOpen, setIsAcknowledgementModalOpen] = useState(false);

    const onSubmit = useCallback((values: any, {setErrors}: FormikHelpers<any>) => {
        setClientMedicalFemaleOnlyInitialValues(values);
        setIsAcknowledgementModalOpen(true);
    }, [])

    const handleAcknowledgementFormSubmit = useCallback((acknowledgementValues:any) => {
        const payload = {
            ...clientMedicalFemaleOnlyInitialValues,
            update_type: "profile",
            client_id:clientId,
            ...acknowledgementValues,
        };
        setIsClientMedicalFemaleOnlyFormSavingInProgress(true);
        CommonService._client.ClientMedicalHistoryFemaleOnlyDetailsSaveAPICall(payload)
            .then((response: IAPIResponseType<IClientMedicalFemaleOnlyForm>) => {
                CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY], "success");
                setIsClientMedicalFemaleOnlyFormSavingInProgress(false);
                setClientMedicalFemaleOnlyInitialValues(_.cloneDeep(clientMedicalFemaleOnlyInitialValues));
                onSave(response);
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error[Misc.API_RESPONSE_MESSAGE_KEY], 'error');
                setIsClientMedicalFemaleOnlyFormSavingInProgress(false);
            })
    }, [onSave,clientId,clientMedicalFemaleOnlyInitialValues]);

    useEffect(() => {
        if (clientMedicalHistoryDetails) {
            setClientMedicalFemaleOnlyInitialValues({
                females_only_questions: clientMedicalHistoryDetails.females_only_questions
            });
        }
    }, [dispatch, clientMedicalHistoryDetails]);

    return (
        <div className={'client-medical-female-only-form-component'}>
            <>
                {
                    isClientMedicalHistoryDetailsLoading && <div>
                        <LoaderComponent/>
                    </div>
                }
                {
                    isClientMedicalHistoryDetailsLoadingFailed &&
                    <StatusCardComponent title={"Failed to fetch medical Details"}/>
                }
            </>
            <HeadingWithNavigationComponent onBackNavigation={onCancel}
                                            title={"Back"}/>
            <Formik
                validationSchema={ClientMedicalFemaleOnlyValidationSchema}
                initialValues={clientMedicalFemaleOnlyInitialValues}
                onSubmit={onSubmit}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}>
                {({values, isValid, validateForm}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                    }, [validateForm, values]);
                    return (<CardComponent>
                            <div className={'edit-female-heading'}>
                                Edit Females Only
                            </div>
                            <Form noValidate={true} className={"t-form"}>
                                <div className={'edit-female-wrapper'}>

                                    <DetailsViewCardComponent title={"Females Only"}>
                                        <div className={'females-heading'}>
                                            Have you ever or do you currently:
                                        </div>
                                        <>
                                            {
                                                FormQuestions.map((question: any) => {
                                                    const {key, title} = question;
                                                    return <>
                                                        <div className="ts-row ts-align-items-center" key={key}>
                                                            <div className="ts-col">
                                                                {title}
                                                            </div>
                                                            <div className="ts-col mrg-top-25">
                                                                <Field name={`females_only_questions.${key}`}>
                                                                    {
                                                                        (field: FieldProps) => (
                                                                            <FormikRadioButtonGroupComponent
                                                                                options={CommonService._staticData.yesNoOptions}
                                                                                displayWith={(option) => option.title}
                                                                                valueExtractor={(option) => option.title}
                                                                                required={true}
                                                                                formikField={field}
                                                                            />
                                                                        )
                                                                    }
                                                                </Field>

                                                            </div>
                                                        </div>
                                                        {question !== FormQuestions[FormQuestions.length - 1] &&
                                                            <HorizontalLineV2Component/>
                                                        }
                                                    </>

                                                })

                                            }

                                        </>
                                    </DetailsViewCardComponent>
                                </div>
                                <div className="t-form-actions mrg-bottom-0">
                                <ButtonComponent
                                        variant={"outlined"}
                                        onClick={onCancel}
                                        disabled={isClientMedicalFemaleOnlyFormSavingInProgress}
                                        color={'accent'}
                                    >
                                        Cancel
                                    </ButtonComponent>&nbsp;
                                    <ButtonComponent
                                        className={'mrg-left-25'}
                                        isLoading={isClientMedicalFemaleOnlyFormSavingInProgress}
                                        disabled={isClientMedicalFemaleOnlyFormSavingInProgress || !isValid || CommonService.isEqual(values, clientMedicalFemaleOnlyInitialValues)}
                                        type={"submit"}
                                        color={'accent'}
                                    >
                                        {isClientMedicalFemaleOnlyFormSavingInProgress ? "Saving" : 'Next'}
                                    </ButtonComponent>
                                </div>
                            </Form>
                        </CardComponent>
                    )
                }}
            </Formik>
            <ModalComponent isOpen={isAcknowledgementModalOpen}>
                <AcknowledgementFormComponent setIsAcknowledgementModalOpen={setIsAcknowledgementModalOpen}
                                              isLoading={isClientMedicalFemaleOnlyFormSavingInProgress}
                                              onSubmit={handleAcknowledgementFormSubmit}/>
            </ModalComponent>
        </div>
    );

};

export default ClientMedicalFemaleOnlyFormComponent;
